// Per-tab access for signed-in department users.
// Circulars / Gallery / Careers each have none | view | edit.
// Admin always has edit on every tab plus Users.

export const TAB_KEYS = ["circulars", "gallery", "careers"];

export function isAdmin(user) {
  return !!user && user.role === "admin";
}

export function tabAccess(user, tab) {
  if (!user) return "none";
  if (user.role === "admin") return "edit";
  const value = String((user.tabs && user.tabs[tab]) || "").toLowerCase();
  if (value === "view" || value === "edit" || value === "none") return value;
  if (user.privilege === "edit" || user.can_edit === true) return "edit";
  if (user.privilege === "view") return "view";
  return "none";
}

export function canViewTab(user, tab) {
  const access = tabAccess(user, tab);
  return access === "view" || access === "edit";
}

export function canEditTab(user, tab) {
  return tabAccess(user, tab) === "edit";
}

export function canEdit(user) {
  if (!user) return false;
  if (user.role === "admin" || user.can_edit === true) return true;
  return TAB_KEYS.some((tab) => tabAccess(user, tab) === "edit");
}

export function visiblePortalTabs(user) {
  const tabs = [{ id: "home", label: "Home" }];
  if (canViewTab(user, "circulars")) tabs.push({ id: "circulars", label: "Circulars" });
  if (canViewTab(user, "gallery")) tabs.push({ id: "gallery", label: "Gallery" });
  if (canViewTab(user, "careers")) tabs.push({ id: "careers", label: "Careers" });
  if (user) tabs.push({ id: "password", label: "Change password" });
  if (isAdmin(user)) tabs.push({ id: "users", label: "Users" });
  return tabs;
}
